import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15 9V6C15 3.23858 12.7614 1 10 1V1C7.23858 1 5 3.23858 5 6V9",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.5 11C3.5 9.89543 4.39543 9 5.5 9H14.5C15.6046 9 16.5 9.89543 16.5 11V16C16.5 17.6569 15.1569 19 13.5 19H6.5C4.84315 19 3.5 17.6569 3.5 16V11Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "10",
      cy: "13.05",
      r: "1.25",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 13V15.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }